import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ComponentReloadService } from '../../shared/services/reload/component-reload.service';
import { ContactsService } from 'src/app/business-service/contacts/contacts.service';
import { ModalsService } from '../../shared/services/modals/modals.service';
import { GlobalService } from '../../shared/services/global/global.service';
import { PopoverController } from '@ionic/angular';
import { GuestDocumentComponent } from '../../shared/popover/guest-document/guest-document.component';
import { TABLE_OPTION_VALUES } from '../../shared/constants/api-constants';
import { HttpClient } from '@angular/common/http';
import { ColumnManageComponent } from '../../shared/popover/column-manage/column-manage.component';
import { TableColumnOptionsComponent } from '../../shared/popover/table-column-options/table-column-options.component';

@Component({
  selector: 'app-passengers-grid-view',
  templateUrl: './passengers-grid-view.component.html',
  styleUrls: ['./passengers-grid-view.component.scss'],
})
export class PassengersGridViewComponent implements OnInit {
  @Input() allData: any
  @Input() data: any;;

  @Input() hidePaginations: boolean = false;
  paginationSettings: any;
  visiblePages: number[] = [];
  noOfRows: any = 0;
  @Output() triggerDeleteRow = new EventEmitter<void>();
  @Output() triggerEditRow = new EventEmitter<void>();
  @Output() triggerViewRow = new EventEmitter<void>();
  @Output() triggerAuditRow = new EventEmitter<void>();

  @Input() columns: any = [];
  @Input() showColumnSelector: boolean = true;
  initialColumns: any = [];

  @Input() hideExtraColumns: boolean = false;

  @Output() paginationsUpdated = new EventEmitter<void>();
  @Output() manageColumnsChange = new EventEmitter<any>();

  // Multi select related variables
  selectedRowIds: any[] = [];
  @Input() multiSelectProperty: string | null = null;

  sortOrder: { [key: string]: 'asc' | 'desc' } = {};

  @Input() showWhatsappActionBtn: boolean = false;
  @Input() showEmailActionBtn: boolean = false;
  @Output() emitWhatsappActionTrigger = new EventEmitter<any[]>();
  @Output() emitEmailActionTrigger = new EventEmitter<any[]>();
  @Output() emitCallActionTrigger = new EventEmitter<any[]>();

  constructor(
    private http: HttpClient,
    private _contactService: ContactsService,
    private _reloadService: ComponentReloadService,
    private _modalPopupService: ModalsService,
    public _globalService: GlobalService,
    private _popoverController: PopoverController
  ) { }

  ngOnInit() {
    this.initialColumns = this.getVisibleColumns(this.columns);
  }

  ngOnChanges() {
    this.data = this.allData.data;

    this.paginationSettings = this.allData;

    // Reset selected rows when data changes
    this.selectedRowIds = [];

    if (this.data && this.data.length) {
      delete this.paginationSettings.data;
      this.noOfRows = this.data.length;
      this.updateVisiblePages();
    }

    if (this.data && this.data.length === 0) {
      this.hidePaginations = true;
    } else {
      this.hidePaginations = false;
    }
  }

  async openPassengerOptionPopover(event: any, row: any) {
    const popover = await this._popoverController.create({
      component: TableColumnOptionsComponent,
      event: event,
      cssClass: 'popup-component',
      componentProps: {
        optionsData: {
          options: [
            {
              value: "View",
              path: TABLE_OPTION_VALUES.VIEW
            },
            {
              value: "Edit",
              path: TABLE_OPTION_VALUES.EDIT
            },
            {
              value: "Audit History",
              path: TABLE_OPTION_VALUES.SHOW_AUDIT
            },
            {
              value: "Delete",
              path: TABLE_OPTION_VALUES.DELETE
            }
          ]
        },
        onPathSelected: (data: any) => this.onPassengerActionOptionSelected(data, row)
      }
    });
    return await popover.present()
  }


  onPassengerActionOptionSelected(data: any, row: any) {
    this._popoverController.dismiss();
    switch (data.path) {
      case TABLE_OPTION_VALUES.DELETE: {
        this.triggerDeleteRow.emit(row.contactId);
        break;
      }
      case TABLE_OPTION_VALUES.EDIT: {
        this.triggerEditRow.emit(row.contactId);
        break;
      }
      case TABLE_OPTION_VALUES.VIEW: {
        this.triggerViewRow.emit(row.contactId);
        break;
      }
      case TABLE_OPTION_VALUES.SHOW_AUDIT: {
        this.triggerAuditRow.emit(row.contactId);
        break;
      }
    }

  }


  // contacts for lead functions

  openFileInNewTab(filePath: string) {
    const fullUrl = `${filePath}`;
    this._modalPopupService.openImageModal(fullUrl)
  }

  async deleteDocument(guest: any, doc: any) {
    if (await this._globalService.confirmActionPopup(`Confirm to delete document ${doc.documentCategory}`)) {
      this._contactService.deleteContactAttachment(guest.contactId, doc.documentCategory).subscribe((data) => {
        this._reloadService.triggerContactsReload();
      })
    }
  }

  async openUploadDocPopover(event: any, guest: any) {
    const formSubmitted: EventEmitter<{ guest: any, documentType: any, file: any, fileName: any }> = new EventEmitter();

    const popover = await this._popoverController.create({
      component: GuestDocumentComponent,
      event: event,
      componentProps: {
        guest: guest,
        formSubmitted: formSubmitted
      },
    });

    formSubmitted.subscribe(({ guest, documentType, file, fileName }) => {
      this.addDocumentToGuestRow(guest, documentType, file, fileName);
    });

    await popover.present();

  }

  // Step 4: Define the handler function for submitted data
  addDocumentToGuestRow(guest: any, documentType: any, file: any, fileName: any) {
    const formData = new FormData();

    // Append simple fields
    formData.append('contactId', guest.contactId);
    formData.append('leadId', guest.leadId);
    formData.append('clientId', guest.clientId || '');
    formData.append('firstName', guest.firstName);
    formData.append('lastName', guest.lastName);
    formData.append('phoneNumber', guest.phoneNumber);
    formData.append('dateOfBirth', guest.dateOfBirth);
    formData.append('phoneCountryCode', guest.phoneCountryCode);
    formData.append('email', guest.email);
    formData.append('age', guest.age);
    formData.append('gender', guest.gender);
    formData.append('company', guest.company);
    formData.append('organizationId', guest.organizationId);

    // Append documents
    formData.append(`document[0].file`, file);
    formData.append(`document[0].documentCategory`, documentType);


    this._contactService.updateContact(guest.contactId, formData).subscribe((data) => {
      this._reloadService.triggerContactsReload();
    })
  }

  toggleDocuments(guest: any) {
    guest.showAllDocs = !guest.showAllDocs;
  }



  // Manage columns

  async openColumnOptions(ev: any) {
    const columnPopOver = await this._popoverController.create({
      component: ColumnManageComponent,
      event: ev,
      componentProps: { columns: this.cloneVariable(this.columns) },
      cssClass: "popup-component"
    })
    await columnPopOver.present();
    const { data } = await columnPopOver.onDidDismiss();
    if (data) {
      this.columns = data;
      this.initialColumns = data.filter((column: { showColumn: any; }) => column.showColumn);
      this.manageColumnsChange.emit(data);
    } else {
      this.resetColumn();
      this.ngOnInit();
    }
  }

  resetColumn() {
    this.initialColumns = this.columns.filter((column: { showColumn: any; }) => column.showColumn);
  }

  getVisibleColumns(columns: any) {
    return columns.filter((column: { showColumn: any; }) => column.showColumn);
  }

  shouldShowColumn(colKey: any): boolean {
    return this.initialColumns.some((column: any) => column.key === colKey && column.showColumn);
  }

  getfullColSpan() {
    let colspan = this.initialColumns.length
    if (this.showColumnSelector) {
      colspan = colspan + 1;
    }
    colspan = colspan + 1;
    return colspan;
  }

  cloneVariable(variable: any) {
    return JSON.parse(JSON.stringify(variable));
  }


  // Multi select variables

  // Check if all rows are selected
  isAllSelected(): boolean {
    if (!this.data || !this.multiSelectProperty) return false;
    return this.data.length > 0 && this.selectedRowIds.length === this.data.length;
  }

  // Toggle all rows
  toggleSelectAllRows(event: any) {
    if (event.target.checked) {
      this.selectedRowIds = this.data.map((row: any) => row[this.multiSelectProperty as string]);
    } else {
      this.selectedRowIds = [];
    }
  }

  // Toggle single row
  toggleSelectRow(event: any, row: any) {
    const id = row[this.multiSelectProperty as string];
    if (event.target.checked) {
      if (!this.selectedRowIds.includes(id)) {
        this.selectedRowIds.push(id);
      }
    } else {
      this.selectedRowIds = this.selectedRowIds.filter(selectedId => selectedId !== id);
    }
  }

  // Utility to check if a row is selected
  isRowSelected(row: any): boolean {
    return this.selectedRowIds.includes(row[this.multiSelectProperty as string]);
  }

  getSelectedRows(): any[] {
    if (!this.data || !this.multiSelectProperty) {
      return [];
    }
    // Only return selected rows that are present in the current page's data
    const selectedRows = this.data.filter((row: any) =>
      this.selectedRowIds.includes(row[this.multiSelectProperty as string])
    );
    return selectedRows;
  }

  areRowsSelected(): boolean {
    if (this.selectedRowIds && this.selectedRowIds.length > 0) {
      return true;
    }
    return false;
  }

  sortData(column: string) {
    // Toggle sort order
    this.sortOrder[column] = this.sortOrder[column] === 'asc' ? 'desc' : 'asc';

    const order = this.sortOrder[column];

    this.data.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const valueA = a[column];
      const valueB = b[column];

      let comparison = 0;

      if (typeof valueA === 'string' && typeof valueB === 'string') {
        comparison = valueA.localeCompare(valueB);
      } else if (typeof valueA === 'number' && typeof valueB === 'number') {
        comparison = valueA - valueB;
      } else if (valueA instanceof Date && valueB instanceof Date) {
        comparison = valueA.getTime() - valueB.getTime();
      }

      return order === 'asc' ? comparison : -comparison;
    });
  }

  // Paginations
  updateVisiblePages() {
    const currentPage = this.paginationSettings.pageNumber;
    const totalPages = this.paginationSettings.totalPages;

    let startPage: number, endPage: number;
    if (totalPages <= 5) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= 3) {
        startPage = 1;
        endPage = 5;
      } else if (currentPage + 2 >= totalPages) {
        startPage = totalPages - 4;
        endPage = totalPages;
      } else {
        startPage = currentPage - 2;
        endPage = currentPage + 2;
      }
    }

    this.visiblePages = Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);
  }

  onPageChange(page: number) {
    if (page !== this.paginationSettings.pageNumber) {
      this.paginationSettings.pageNumber = page;
      this.updateVisiblePages();
      this.loadPageData();
    }
  }

  onNext() {
    if (this.paginationSettings.pageNumber < this.paginationSettings.totalPages) {
      this.paginationSettings.pageNumber++;
      this.updateVisiblePages();
      this.loadPageData();
    }
  }

  onPrevious() {
    if (this.paginationSettings.pageNumber > 1) {
      this.paginationSettings.pageNumber--;
      this.updateVisiblePages();
      this.loadPageData();
    }
  }

  onPageSizeChange() {
    this.paginationSettings.pageNumber = 1;
    this.updateVisiblePages();
    this.loadPageData();
  }

  loadPageData() {
    this.paginationsUpdated.emit(this.paginationSettings);
  }
}
